var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGrowtharrowupRed(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.7678 2.23223C24.7915 1.25592 23.2085 1.25592 22.2322 2.23223L6.32233 18.1421C5.34602 19.1184 5.34602 20.7014 6.32233 21.6777C7.29864 22.654 8.88155 22.654 9.85787 21.6777L24 7.53553L38.1421 21.6777C39.1184 22.654 40.7014 22.654 41.6777 21.6777C42.654 20.7014 42.654 19.1184 41.6777 18.1421L25.7678 2.23223ZM26.5 43L26.5 4L21.5 4L21.5 43L26.5 43Z",
    fill: "#CA2A2B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGrowtharrowupRed);
export default __webpack_public_path__ + "static/media/growth arrow up_red.6f004914c6b68e3b50a8b798cee08540.svg";
export { ForwardRef as ReactComponent };